import PropTypes from 'prop-types'
import { IconProps } from './types/IconProps'

const FilterIcon = ({ className, onClick }: IconProps) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    onClick={onClick}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3 6V8H21V6H3ZM10 18H14V16H10V18ZM18 13H6V11H18V13Z'
    />
  </svg>
)

FilterIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
}

export default FilterIcon
